module.exports = __webpack_public_path__ + "media/images/theme/default/lab-book-logo-1da8a7cda60c013bd796ea38b8fc19d4.png";